import { isNil } from 'lodash-es'

import { TRoomDetail, TContractRoomDetail } from '@/entities/room'

import { Heading, Item, Label, List, Value } from '../common'

export type Props = Pick<
  TRoomDetail,
  | 'includeElectricity'
  | 'includeWater'
  | 'includeGas'
  | 'managementFeeDescription'
> &
  Partial<Pick<TContractRoomDetail, 'includeInternet'>>

export const ManagementFee = ({
  includeElectricity,
  includeWater,
  includeGas,
  includeInternet,
  managementFeeDescription,
}: Props) => {
  const showInternet = !isNil(includeInternet)

  return (
    <section className="flex justify-between">
      <div className="w-[260px] space-y-5">
        <Heading>관리비 포함 항목</Heading>
        <List spacing="medium" className="typo-body2 text-gray-900">
          <Item className="justify-between">
            <Label icon="gas" className="font-semibold">
              가스
            </Label>
            <Value>{includeGas ? '포함' : '불포함'}</Value>
          </Item>
          <Item className="justify-between">
            <Label icon="water" className="font-semibold">
              수도
            </Label>
            <Value>{includeWater ? '포함' : '불포함'}</Value>
          </Item>
          <Item className="justify-between">
            <Label icon="electricity" className="font-semibold">
              전기
            </Label>
            <Value>{includeElectricity ? '포함' : '불포함'}</Value>
          </Item>
          {showInternet && (
            <Item className="justify-between">
              <Label icon="wifi" className="font-semibold">
                인터넷
              </Label>
              <Value>{includeInternet ? '포함' : '불포함'}</Value>
            </Item>
          )}
        </List>
      </div>

      <div className="w-[330px] space-y-3">
        <Heading>관리비 안내</Heading>
        <p className="typo-body2 font-normal whitespace-break-spaces text-gray-900">
          {managementFeeDescription}
        </p>
      </div>
    </section>
  )
}
